const EMAIL_ADDRESS_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function splitEmailList(value: string | null | undefined): string[] {
  if (!value) return [];

  return value
    .split(",")
    .map((token) => token.trim())
    .filter((token) => token.length > 0);
}

export function joinEmailList(emails: string[]): string {
  return [...new Set(emails.flatMap((email) => splitEmailList(email)))].join(",");
}

export function emailAddressFromToken(token: string): string {
  const stripped = token.trim();
  const match = stripped.match(/^.*<([^>]+)>$/);
  return (match?.[1] ?? stripped).trim();
}

export function isValidEmailToken(token: string): boolean {
  return EMAIL_ADDRESS_REGEX.test(token.trim());
}

export function emailFieldError(value: string): string | undefined {
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const tokens = splitEmailList(trimmed);
  if (tokens.length === 0 || tokens.some((token) => !isValidEmailToken(token))) {
    return "Enter a valid email.";
  }

  return undefined;
}

export function emailsForInputs(value: string | null | undefined): string[] {
  const emails = splitEmailList(value)
    .map(emailAddressFromToken)
    .filter((email) => isValidEmailToken(email));
  return emails.length > 0 ? emails : [""];
}
